import { NoticeType } from '@atlassian/proforma-common-core/jira-common';
import { showNotice } from '@atlassian/proforma-common-core/jira-common-utils';
import { setSelectedFormId } from '../set-selected-form-id';
export const deleteFormOld = (formId, formName) => async ({
  getState,
  setState,
  dispatch
}, {
  api
}) => {
  const {
    permissions
  } = getState();
  if (!permissions.delete) {
    return Promise.reject(new Error('no permissions to delete'));
  }
  const isConfirmed = await showNotice(NoticeType.ConfirmDeleteForm, {
    msgVars: {
      formName
    }
  });
  if (isConfirmed) {
    setState({
      isIndexLoading: true
    });
    try {
      await api.deleteForm(formId);
      const deletedFormIndexItem = getState().formIndex.find(formIndex => formIndex.id === formId);
      setState({
        formIndex: getState().formIndex.filter(formIndexItem => formIndexItem.id !== (deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.id))
      });

      // unset if it is the current selected form
      if (getState().selectedFormId === (deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.id)) {
        await dispatch(setSelectedFormId());
      }
      return deletedFormIndexItem === null || deletedFormIndexItem === void 0 ? void 0 : deletedFormIndexItem.projectFormId;
    } finally {
      setState({
        isIndexLoading: false
      });
    }
  }
  return Promise.reject(new Error('cancelled'));
};